import {modalCommentLink} from "./hoc/modalCommentLink";

const WaybillV2BulkResponsiblePersonReturn = modalCommentLink("WaybillV2BulkResponsiblePersonReturn")

export default WaybillV2BulkResponsiblePersonReturn